/* Dawnstep cart: slide-out drawer + cart page actions (quantity, remove, add-on). */
(function () {
  var DS = (window.DSCart = window.DSCart || {});
  var drawer = function () { return document.querySelector('[data-ds-drawer]'); };
  var isCartPage = function () { return /^\/cart\/?$/.test(location.pathname); };

  function updateBubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      var n = b.querySelector('.cart-bubble__text-count');
      if (n) { n.textContent = count > 0 ? String(count) : ''; n.classList.toggle('hidden', !(count > 0)); }
      b.classList.toggle('visually-hidden', !(count > 0));
    });
  }

  function render(container) {
    var src = container.getAttribute('data-src');
    container.classList.add('is-busy');
    return fetch(src, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ds-cart]');
        if (fresh) { container.replaceWith(fresh); updateBubble(parseInt(fresh.getAttribute('data-count'), 10) || 0); }
        return fresh;
      })
      .catch(function () { container.classList.remove('is-busy'); });
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }

  DS.open = function () {
    var d = drawer();
    if (!d) { location.href = '/cart'; return; }
    var mount = d.querySelector('[data-ds-cart-mount]');
    d.hidden = false;
    document.documentElement.classList.add('ds-drawer-lock');
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    fetch('/?section_id=ds-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ds-cart]');
        if (fresh) { mount.innerHTML = ''; mount.appendChild(fresh); updateBubble(parseInt(fresh.getAttribute('data-count'), 10) || 0); }
        var x = d.querySelector('[data-ds-close].ds-cartbody__x'); if (x) x.focus({ preventScroll: true });
      });
  };

  DS.close = function () {
    var d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('ds-drawer-lock');
    setTimeout(function () { d.hidden = true; }, 280);
  };

  document.addEventListener('click', function (e) {
    // header cart icon opens the drawer instead of the cart page
    var cartLink = e.target.closest('a.action__cart, header a[href="/cart"]');
    if (cartLink && !isCartPage() && drawer()) { e.preventDefault(); DS.open(); return; }

    if (e.target.closest('[data-ds-close]')) { DS.close(); return; }

    var box = e.target.closest('[data-ds-cart]');
    if (!box) return;
    if (e.target.closest('[data-ds-drawer] a[href]')) { DS.close(); return; }

    var li = e.target.closest('[data-line]');
    var q = e.target.closest('[data-qty]');
    if (q && li) {
      var cur = parseInt(li.querySelector('.ds-qty span').textContent, 10) || 1;
      box.classList.add('is-busy');
      post('/cart/change.js', { line: parseInt(li.getAttribute('data-line'), 10), quantity: Math.max(0, cur + parseInt(q.getAttribute('data-qty'), 10)) }).then(function () { render(box); });
      return;
    }
    if (e.target.closest('[data-remove]') && li) {
      box.classList.add('is-busy');
      post('/cart/change.js', { line: parseInt(li.getAttribute('data-line'), 10), quantity: 0 }).then(function () { render(box); });
      return;
    }
    if (e.target.closest('[data-bar-checkout]')) { var b = box.querySelector('.ds-sum__checkout'); if (b) b.click(); return; }
    var addBtn = e.target.closest('[data-up-add]');
    if (addBtn) {
      var up = addBtn.closest('[data-upsell]');
      var variants = JSON.parse(up.querySelector('[data-up-variants]').textContent);
      var sel = Array.prototype.map.call(up.querySelectorAll('[data-up-opt]'), function (s) { return s.value; });
      var empty = Array.prototype.find.call(up.querySelectorAll('[data-up-opt]'), function (s) { return !s.value; });
      if (empty) { empty.focus(); empty.classList.add('ds-pulse'); setTimeout(function () { empty.classList.remove('ds-pulse'); }, 1600); addBtn.textContent = 'Choose a size first'; return; }
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v || !v.available) { addBtn.textContent = 'That size is sold out'; return; }
      box.classList.add('is-busy');
      post('/cart/add.js', { items: [{ id: v.id, quantity: 1, properties: { Guarantee: '30-day refund' } }] }).then(function () { render(box); });
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') DS.close(); });
  // never come back to an open drawer (back/forward cache)
  window.addEventListener('pageshow', function (e) { if (e.persisted) { var d = drawer(); if (d) { d.classList.remove('is-open'); d.hidden = true; document.documentElement.classList.remove('ds-drawer-lock'); } } });
  window.addEventListener('pagehide', function () { var d = drawer(); if (d) { d.classList.remove('is-open'); d.hidden = true; } });
})();
